import { render, staticRenderFns } from "./GatGridGroupHeader.vue?vue&type=template&id=6f243777&scoped=true&"
import script from "./GatGridGroupHeader.vue?vue&type=script&lang=js&"
export * from "./GatGridGroupHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f243777",
  null
  
)

export default component.exports